import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalService } from 'src/app/core/services/modal.service';
import { PaButtonComponent } from 'src/app/shared/ui-kit/pa-button/pa-button.component';
import { PaInfoBlockComponent } from 'src/app/shared/ui-kit/pa-info-block/pa-info-block.component';
import { StepperDemoModalComponent } from './stepper-demo-modal/stepper-demo-modal.component';

@Component({
  selector: 'app-stepper-view',
  standalone: true,
  imports: [PaButtonComponent, PaInfoBlockComponent],
  templateUrl: './stepper-view.component.html',
  styleUrls: ['./stepper-view.component.scss'],
})
export class StepperViewComponent {
  private readonly modalService = inject(ModalService);
  private readonly destroy = inject(DestroyRef);

  openStepperModal(): void {
    this.modalService
      .create({
        component: StepperDemoModalComponent,
        viewConfig: { backdropDismiss: false },
      })
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe();
  }
}
